import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Toolbar,
    Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import styles from './RemoveDeliveryTypeModal.module.scss';
import { removeSupplierDeliveryType } from 'lib/firebase';

export interface RemoveDeliveryTypeModalProps {
    open: boolean;
    onClose: () => void;
    /** Name of the delivery type to remove. */
    deliveryTypeName: string;
    supplierId: string;
    onRemoveDeliveryType: (deliveryTypeName: string) => void;
}

export const RemoveDeliveryTypeModal = ({
    open,
    onClose,
    deliveryTypeName,
    supplierId,
    onRemoveDeliveryType,
}: RemoveDeliveryTypeModalProps) => {
    const deleteDeliveryType = () => {
        removeSupplierDeliveryType(supplierId, deliveryTypeName).then(() => {
            onRemoveDeliveryType(deliveryTypeName);
            // Close modal when delivery type is successfully removed.
            onClose();
        });
    };

    return (
        <div data-testid="RemoveDeliveryTypeModal">
            <Dialog
                open={open}
                onClose={onClose}
                className={styles.RemoveDeliveryTypeModal}
                maxWidth="sm"
                fullWidth={true}
            >
                <Toolbar>
                    <Typography className={styles.modalHeader} variant="h6">
                        Delete Delivery Type?
                    </Typography>
                    <IconButton
                        data-testid="x-button"
                        color="inherit"
                        onClick={() => onClose()}
                        aria-label="close"
                    >
                        <Close />
                    </IconButton>
                </Toolbar>
                <DialogContent>
                    Are you sure you want to delete the delivery type:{' '}
                    {deliveryTypeName}?
                </DialogContent>
                <DialogActions>
                    <Button
                        aria-label="cancel"
                        variant="text"
                        color="primary"
                        onClick={() => onClose()}
                        data-testid="cancel-button"
                    >
                        Cancel
                    </Button>
                    <Button
                        aria-label="delete"
                        variant="contained"
                        color="primary"
                        onClick={() => deleteDeliveryType()}
                        data-testid="delete-button"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
